import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import CvPageLayout from '../../../components/CvPageLayout';
import DescriptionForm from '../../../components/DescriptionForm';

function CvEmploymentDescription() {
  const [description, setDescription] = useState([]);

  return (
    <CvPageLayout currentStep="Doświadczenie">
      <Row className="justify-content-md-center mt-3">
        <Col>
          <DescriptionForm
            backlink="/cv-career/cv-generator/section/experience/form"
            nextlink="/cv-career/cv-generator/section/experience"
            description={description}
            setDescription={setDescription}
          />
        </Col>
      </Row>
    </CvPageLayout>
  );
}

export default CvEmploymentDescription;
